import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ProductListClearItem from '../clear_item';
import ProductListDropdownItem from '../dropdown_item';
import { SVGs } from '../../../common/fa_icons';
import { colorClassName } from '../../../../utils/shopping';
import { nodeAttrs } from '../../../../utils/dom';
import classNames from 'classnames';
import {map, get, find, noop, includes} from 'lodash';

export const DEPARTMENT_LABEL_TYPE = 'department';
export const SORT_LABEL_TYPE = 'sort';
export const PRICE_LABEL_TYPE = 'price';
export const TYPE_LABEL_TYPE = 'type';

export default class ProductListMobileFilter extends Component {
  currentFilter = () => find(
    this.props.dropdownItems,
    { id: parseInt(this.props.filter) }
  );

  filterName = () =>
    this.props.label === SORT_LABEL_TYPE || this.props.label === PRICE_LABEL_TYPE
      ? get(this.props, 'filter', '')
      : get(this.currentFilter(), 'name', '');

  toggleDropdown = () =>
    this._ul.style.maxHeight = this._ul.style.maxHeight
      ? null
      : `${nodeAttrs(this._ul).scrollHeight}px`;

  handleClick = (event) => {
    const {
      handleFilter = noop,
      label,
      toggleFilterVisibility
    } = this.props;

    handleFilter(event);
    this.toggleDropdown();

    if (label === TYPE_LABEL_TYPE) {
      toggleFilterVisibility();
    }
  };

  render() {
    const {
      activeTopLevelCategoryName,
      dropdownItems,
      label,
      handleFilter = noop
    } = this.props;
    const filterName = this.filterName();
    const shouldDisplayClearOptions = filterName && label !== SORT_LABEL_TYPE;

    return (
      <div className={`mobile-filter-wrapper ${label}`} onClick={this.toggleDropdown}>
        <div className="mobile-filter">
          <span className="label" dangerouslySetInnerHTML={{ __html: label }} />
          <span
            className={classNames(
              'filter-name',
              colorClassName(filterName, label)
            )}
            dangerouslySetInnerHTML={{
              __html: filterName || activeTopLevelCategoryName
            }}
          />
          <span className="fa fa-chevron-down"
            dangerouslySetInnerHTML={{ __html: SVGs['chevron-down'] }}
          />
          {
            shouldDisplayClearOptions &&
              <span className="fa fa-times"
                onClick={handleFilter}
                data-label={label}
                dangerouslySetInnerHTML={{ __html: SVGs.times }}
              />
          }
        </div>
        <ul ref={node => this._ul = node}>
          {
            map(dropdownItems, ({ id, name, path }, i) => (
              <ProductListDropdownItem key={id || i}
                handleClick={this.handleClick}
                id={id}
                label={label}
                name={name}
                path={path}
                shouldBeSelected={includes([
                  filterName,
                  activeTopLevelCategoryName
                ], name)}
              />
            ))
          }
          {
            shouldDisplayClearOptions && (
              <ProductListClearItem
                handleClick={this.handleClick}
                label={label}
              />
            )
          }
        </ul>
      </div>
    );
  }
}

ProductListMobileFilter.propTypes = {
  dropdownItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string
    }).isRequired
  ),
  handleFilter: PropTypes.func,
  filter: PropTypes.string,
  label: PropTypes.string.isRequired,
  activeTopLevelCategoryName: PropTypes.string,
  toggleFilterVisibility: PropTypes.func
};
